module.exports = __webpack_public_path__ + "static/media/security_4.877233fa.png";